<template>
    <div class="item tw-flex tw-items-center hover:tw-bg-blue-100 tw-cursor-pointer" @click="onItemClick(result)">
        <div class="tw-mr-4 avatar-container">
            <thread-avatar :participants="profile"></thread-avatar>
        </div>
        <div class="tw-flex tw-items-center tw-w-full">
            <div>
                <div class="tw-flex tw-items-center">
                    <thread-name :participants="profile"></thread-name>

                    <template v-if="result.isAdmin || result.isModerator">
                        <role-label :admin="result.isAdmin"
                                    :moderator="!result.isAdmin && result.isModerator"></role-label>
                    </template>

                </div>
                <span v-if="truncatedMessage" v-text="truncatedMessage"></span>
                <span v-else v-text="result.username" class="tw-break-all"></span>
            </div>

            <div class="tw-ml-auto tw-px-5 tw-text-3xl">
                <div @click.stop="goToProfile">
                    <i class="fal fa-id-badge"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RoleLabel from './icons/RoleLabel';
import ThreadAvatar from './ThreadAvatar';
import ThreadName from './ThreadName';

export default {
	name: 'SearchItem',
	props: ['result'],
	components: {
		'thread-avatar': ThreadAvatar,
		'thread-name': ThreadName,
		'role-label': RoleLabel,
	},
	computed: {
		profile() {
			return [this.result];
		},
		truncatedMessage() {
			return this.result.thread
				? this.result.thread.messages[0].body.length > 30
					? this.result.thread.messages[0].body.slice(0, 30) + '...'
					: this.result.thread.messages[0].body
				: null;
		},
	},
	methods: {
		goToProfile() {
			window.open(`/profile/${this.result.username}`, '_blank');
		},
		onItemClick(result) {
			const user_id = result.id;
			this.$emit('item-click', user_id);
		},
	},
};
</script>
<style lang="scss" scoped>
    .item {
        padding: 17px;
        margin: 16px;
        border-radius: 10px;

        &:first-of-type {
            margin-top: 10px;
        }
    }

    .name {
        margin-bottom: 2px;
    }

    .time {
        font-size: 11px;
    }

    .avatar-container {
        width: 80px;
    }
</style>
